/** Descarga un `Blob` en el navegador con el nombre dado (enlace temporal + click + limpieza). */
export function descargarBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = fileName;
  document.body.appendChild(enlace);
  enlace.click();
  document.body.removeChild(enlace);
  URL.revokeObjectURL(url);
}
